<template>
  <div>
    <div class="card m-1" >
      <div class="card-body maadi-dark-card">
        <div v-if="!isFiltering" class="m-2 pb-3 pt-3 d-flex" style="border: 1px solid #3E597A" v-for="member in members" :key="member.id">
          <single-organization-result-v2 v-bind:organization="member"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MembershipDashboardMixin from './MembershipDashboardMixin'
import SingleOrganizationResultV2 from '../organizations/search/SingleOrganizationResult'
import {EventBus} from '../../utils/EventBus'
export default {
  name: '',
  mixins: [MembershipDashboardMixin],
  components: {SingleOrganizationResultV2},
  data: function () {
    return {
      selectedMembers: null,
      filter: {},
      isFiltering: false
    }
  },
  mounted () {
    EventBus.$on('members-selected', message => {
      this.selectedMembers = this.members.filter((x) => message.indexOf(x.account_id) > -1)
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/membership/MembershipListDashboard.vue